(function(angular) {
  'use strict';

  angular.module('esn.calendar')
    .component('calSettingsSubheader', {
      template: require('./settings-subheader.pug')
    });
})(angular);
